import styled from "styled-components";
import cssVars from "../../../styles/cssVariables.vars";

export const StyledNumerosWhatsapp = styled.div`
    box-sizing: border-box;
    padding: 1rem;
    height: calc(100% - 4rem);
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    >header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        flex-wrap: wrap;

        >div {
            >h2 {
                font-size: 1.25rem;
                font-weight: 600;
                color: ${cssVars.colorGrey[1]};
            }

            >p {
                margin-top: 0.25rem;
                font-size: 0.8125rem;
                color: ${cssVars.colorGrey[4]};
            }
        }

        >button {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 0.875rem;
            border-radius: 0.25rem;
            border: 1px solid ${cssVars.colorGrey[4]};
            background-color: transparent;
            color: ${cssVars.colorGrey[2]};
            font-size: 0.8125rem;
            font-weight: 500;
            cursor: pointer;

            &:hover:not([disabled]) {
                background-color: ${cssVars.colorGrey[2]};
                color: ${cssVars.colorGrey[8]};
            }

            &[disabled] {
                opacity: 0.5;
                cursor: default;
            }
        }
    }

    >.notice {
        padding: 1rem;
        border-radius: 0.5rem;
        background-color: ${cssVars.colorGrey[7]};
        font-size: 0.875rem;
        line-height: 1.5;
        color: ${cssVars.colorGrey[3]};

        &.error {
            border-left: 4px solid rgb(220, 60, 55);
        }

        &.qr {
            display: flex;
            align-items: center;
            gap: 1rem;
            flex-wrap: wrap;

            >div {
                padding: 0.5rem;
                background-color: white;
                border-radius: 0.25rem;
                line-height: 0;
            }

            >p {
                flex: 1;
                min-width: 12rem;
            }
        }

        >button {
            margin-top: 0.75rem;
            padding: 0.375rem 0.75rem;
            border-radius: 0.25rem;
            border: 1px solid ${cssVars.colorGrey[4]};
            background-color: transparent;
            color: ${cssVars.colorGrey[2]};
            cursor: pointer;
        }
    }

    >.sessions {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(min(100%, 24rem), 1fr));
        gap: 1rem;
        align-items: stretch;
    }
`;
